import defaultLegalAgreementCheckbox from '#themes/default/default/components/legalAgreementCheckbox/legalAgreementCheckbox.js';

import cCheckbox from '#themes/default/web/components/checkbox/checkbox.js';

export default {
	components: {
		cCheckbox
	},
	extends: defaultLegalAgreementCheckbox
};
